var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":"50%","title":_vm.title},on:{"closed":function($event){return _vm.$emit('closed')},"shown":_vm.expand}},[_c('ul',{staticClass:"error-modal"},[_c('Log',{ref:"log",attrs:{"log":_vm.log}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }